// =============================
// Imports
// =============================

import { PureComponent } from 'react';

import { withTranslation } from '../../../config/i18n';

import Responsive from '../responsive';

import EntityActionsDesktop from './desktop';
import EntityActionsMobile from './mobile';

// =============================
// Component
// =============================

class EntityActions extends PureComponent {
  static displayName = 'EntityActionsResponsive';

  render() {
    return (
      <Responsive
        DesktopComponent={EntityActionsDesktop}
        MobileComponent={EntityActionsMobile}
        props={this.props}
      />
    );
  }
}

export default withTranslation('components')(EntityActions);
